module.exports = __webpack_public_path__ + "static/media/close-x.c1b1de25.svg";